"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _RadioModule = _interopRequireDefault(require("./Radio.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * # Radio
 * Simple Foodbomb Radio Tag
 */
var FBRadio = function FBRadio(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/_react.default.createElement(_core.Radio, _extends({}, props, {
    classes: {
      root: _RadioModule.default.FBRadio,
      checked: _RadioModule.default.FBRadio__checked
    }
  }));
};

var _default = FBRadio;
exports.default = _default;

//# sourceMappingURL=Radio.js.map